import React from 'react';
import { Layout } from '../components/Layout';
import { TransportSuivi } from '../components/TransportSuivi';

export default function TransportSuiviPage() {
  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <TransportSuivi />
      </div>
    </Layout>
  );
}
